var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7_3618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6074 65.998C36.8434 64.9011 38.5776 61.3886 37.4807 58.1525C36.3837 54.9165 32.8712 53.1823 29.6351 54.2793C26.3991 55.3762 24.665 58.8887 25.7619 62.1248C26.8588 65.3608 30.3713 67.0949 33.6074 65.998Z",
    fill: "#BCDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8445 13.5464C53.1295 12.5562 50.9365 13.1438 49.9464 14.8588L46.9754 20.0048C45.9852 21.7198 46.5728 23.9127 48.2878 24.9029C50.0029 25.8931 52.1958 25.3055 53.186 23.5904L56.157 18.4445C57.1472 16.7295 56.5596 14.5365 54.8445 13.5464Z",
    fill: "#BCDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1455 65.3035C50.6945 61.4165 59.0964 44.2151 59.2049 43.9955C63.7562 34.7726 60.2364 23.7384 51.3433 19.3498C42.4502 14.9613 31.5514 18.8804 27.0001 28.1032C26.767 28.5757 18.6721 45.8201 14.0182 45.995L53.1455 65.3035Z",
    fill: "#BCDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9668 67.3391L14.0927 49.636C12.7002 48.9489 12.1284 47.2629 12.8156 45.8704L12.8608 45.7788C13.5479 44.3863 15.2339 43.8145 16.6264 44.5017L52.5005 62.2047C53.893 62.8918 54.4648 64.5778 53.7776 65.9703L53.7324 66.0619C53.0452 67.4545 51.3594 68.0263 49.9668 67.3391Z",
    fill: "#BCDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1397 62.6733C36.9683 62.6733 36.7943 62.635 36.6301 62.554L26.7687 57.6875C26.1973 57.4056 25.9628 56.714 26.2447 56.1426C26.5266 55.5714 27.2182 55.3367 27.7896 55.6186L37.6511 60.485C38.2224 60.7669 38.4569 61.4586 38.1751 62.0299C37.974 62.4371 37.5649 62.6733 37.1397 62.6733Z",
    fill: "#65B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6216 23.3658L16.5691 26.0302C16.6097 26.1443 16.69 26.2347 16.7914 26.2804L19.1585 27.347C19.4929 27.4976 19.4929 28.0304 19.1585 28.1812L16.7914 29.2477C16.69 29.2934 16.6097 29.3837 16.5691 29.4978L15.6216 32.1622C15.4878 32.5386 15.0143 32.5386 14.8805 32.1622L13.933 29.4978C13.8924 29.3837 13.8121 29.2933 13.7107 29.2477L11.3436 28.1812C11.0092 28.0305 11.0092 27.4977 11.3436 27.347L13.7107 26.2804C13.8121 26.2347 13.8924 26.1443 13.933 26.0302L14.8805 23.3658C15.0143 22.9895 15.4877 22.9895 15.6216 23.3658Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3859 12.2094L28.0888 14.1857C28.1189 14.2703 28.1784 14.3374 28.2536 14.3713L30.0095 15.1623C30.2576 15.2741 30.2576 15.6693 30.0095 15.7811L28.2536 16.5722C28.1784 16.6061 28.1189 16.6731 28.0888 16.7578L27.3859 18.7341C27.2866 19.0133 26.9355 19.0133 26.8362 18.7341L26.1333 16.7578C26.1032 16.6731 26.0437 16.6061 25.9685 16.5722L24.2126 15.7811C23.9646 15.6693 23.9646 15.2741 24.2126 15.1623L25.9685 14.3713C26.0437 14.3374 26.1032 14.2703 26.1333 14.1857L26.8362 12.2094C26.9355 11.9302 27.2866 11.9302 27.3859 12.2094Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8838 21.6775C68.1317 20.5622 67.4286 19.4571 66.3134 19.2091C65.1981 18.9612 64.0929 19.6643 63.845 20.7796C63.597 21.8948 64.3001 23 65.4154 23.2479C66.5307 23.4959 67.6358 22.7928 67.8838 21.6775Z",
    fill: "#BCDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3742 18.5819C17.8671 18.5819 18.2666 18.1824 18.2666 17.6895C18.2666 17.1966 17.8671 16.797 17.3742 16.797C16.8813 16.797 16.4817 17.1966 16.4817 17.6895C16.4817 18.1824 16.8813 18.5819 17.3742 18.5819Z",
    fill: "#BCDEFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7_3618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationColor);
export default __webpack_public_path__ + "static/media/NotificationColor.5e3129541a0c4fa056f5c90dea02eb19.svg";
export { ForwardRef as ReactComponent };